import { fr } from "./fr";
import { en } from "./en";

export type Locale = "fr" | "en";

export const translations = {
  fr,
  en,
} as const;

export type Translations = typeof fr;

/**
 * Get nested translation value by dot notation path
 */
export function getTranslation(
  locale: Locale,
  path: string
): string {
  const keys = path.split(".");
  let value: unknown = translations[locale];

  for (const key of keys) {
    if (value && typeof value === "object" && key in value) {
      value = (value as Record<string, unknown>)[key];
    } else {
      // Fallback to French if key not found
      value = translations.fr;
      for (const k of keys) {
        if (value && typeof value === "object" && k in value) {
          value = (value as Record<string, unknown>)[k];
        } else {
          return path; // Return path if not found
        }
      }
      break;
    }
  }

  return typeof value === "string" ? value : path;
}

export { fr, en };
